const wrappedContracts: Record<number, string> = {
  1: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
  5: '0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6',
  10: '0x4200000000000000000000000000000000000006',
  137: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
  42161: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
}

export default wrappedContracts
